<template>
  <BaseNoticeItem>
    <template #head>
      <strong>FLSA Classification Pending</strong>
    </template>
    <template #body>
      <div>
        Your FLSA classification is currently being determined by the Worksome team. Once the
        classification is completed, the worker will be able to sign the contract.
      </div>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
})
</script>
